export default __webpack_public_path__ + "static/media/meditation-banner.d763d740.png";